import React from 'react';
import { DataContainer } from 'components/DataContainer';
import HomePageCategories from 'components/HomePageCategories';
import Loader from 'components/Loader';
import PromotionBannerWrapper from 'components/PromotionBanner';
import SearchHistoryOverview from 'components/SearchHistoryOverview';
import { PromotionBannerCarousel } from 'domains/promotion/Promotion.types';
import { PortfolioCard, PortfolioCardProps } from 'pages/HomePage/HomePage';
import { HomepageLinks } from 'pages/HomePage/links/HomepageLinks';
import SearchBar from 'pages/HomePage/search/SearchBar';
import CurrentPromotionsPageBanner from 'pages/PromotionPage/CurrentPromotionsPageBanner';
import { Carousel, Container, Grid, MarginBox } from 'UI';
import { NO_DATA } from 'utils';

export const HomepageLg = ({
  banners,
  bannersWithImage,
  portfolioData,
}: {
  banners: NO_DATA | PromotionBannerCarousel[];
  bannersWithImage: PromotionBannerCarousel[];
  portfolioData: Array<PortfolioCardProps>;
}) => {
  return (
    <Container size={'xxl'} data-cy={'home-page'}>
      <MarginBox mt={30} />
      <SearchBar />
      <MarginBox mt={30} />
      <SearchHistoryOverview redirectToCatalog={true} />
      <>
        <MarginBox mt={30} />
        <DataContainer data={banners} Loading={() => <Loader height={'400px'} />} NotFound={() => <></>}>
          <MarginBox mt={15} />
          {bannersWithImage.length > 0 && (
            <Carousel>
              {bannersWithImage.map((banner) => (
                <PromotionBannerWrapper key={banner.promotionId} banner={banner} />
              ))}
            </Carousel>
          )}
          <MarginBox mt={30} />
          <CurrentPromotionsPageBanner homepage />
          <MarginBox mt={30} />
        </DataContainer>
        <MarginBox mt={15} />
        <HomepageLinks />
        <MarginBox mt={30} />
        <HomePageCategories />
        <Grid
          columns={[1, 2]}
          gutter={[
            [30, 30],
            [30, 30],
          ]}
        >
          {portfolioData.map((data, i) => (
            <PortfolioCard key={`portfolio-${i}`} {...data} index={i} />
          ))}
        </Grid>
        <MarginBox mt={30} />
      </>
    </Container>
  );
};
